var $ = jQuery;
function init(){
	let domain = window.location.host;

	if (window.location.host.indexOf('atscalev2stg.wpengine.com') > -1) {
		domain = 'atscalev2stg.wpengine.com'
	}
	
	function setCookie(name, value, hostOnly, days) {
		let expires = '';
		if (days) {
			let date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = '; expires=' + date.toUTCString();
		}
	
		if (hostOnly) {
			document.cookie = name + "=" + (value || '') + expires + '; path=/';
		} else {
			document.cookie = name + "=" + (value || '') + expires + '; path=/;domain=' + domain;
		}
	}
	
	function getCookie(name) {
		const cookie = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
		if (cookie) {
			return cookie[2];
		}
	
		return false;
	}
	
	function getSubCookie(name, subname) {
		const cookie = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
		if (!cookie) {
			return false;
		}
	
		const cookieVal = cookie[2];
		const subcookies = cookieVal.split('|');
		for (let i = 0; i < subcookies.length; i++) {
			let subcookie = subcookies[i].split('=');
			if (subcookie[0] === subname) {
				return subcookie[1];
			}
		}
	}
	
	function deleteCookie(name) {
		setCookie(name, '');
	}

	function getURLParameter( param ) {
		const params = window.location.search.substr(1).split( '&' );
			for ( let i = 0; i < params.length; i++ ) {
				let p = params[i].split('=');
				if ( p[0] == param ) {
					return decodeURIComponent( p[1] );
				}
			}
		return false;
	}
	
	
	function getUTMSource() {
		if( getURLParameter( 'utm_source' ) ) {
			return getURLParameter( 'utm_source' );
		}
	
		if( getURLParameter( 'gclid' ) || document.referrer.indexOf('google.com') > 0 ) {
			return 'google';
		}
	
		if( document.referrer ) {
			return document.referrer;
		}
	
		return 'direct';
	}
	
	function getUTMMedium() {
		if( getURLParameter( 'utm_medium' ) ) {
			return getURLParameter( 'utm_medium' );
		}
	
		if( getURLParameter( 'gclid' ) ) {
			return 'cpc';
		}
	
		if( document.referrer.indexOf('google.com') > 0 ) {
			return 'organic';
		}
	
		if( document.referrer ) {
			return 'referral';
		}
	
		return 'none';
	}
	
	const utm = {
		'utm_campaign': getURLParameter( 'utm_campaign' ), 
		'utm_content': getURLParameter( 'utm_content' ),
		'utm_medium': getUTMMedium(),
		'utm_source': getUTMSource(),
		'utm_term': getURLParameter( 'utm_term' )
	};
	
	// Set cookie with utm params. Used to carry over params to hubspot forms.
	let utmCookie = '';
	let separator = '';
	
	Object.keys( utm ).forEach( function ( key, i ) {
		let value = utm[key] ? utm[key] : 'null';
		
		if( i > 0 ) {
			separator = '|';
		} 
	
		utmCookie = utmCookie + separator + key + '=' + value;
		
	});
	
	const hasUtmCookie = getCookie( 'a_utm' );
	
	if( !hasUtmCookie && utmCookie ) {
		setCookie( 'a_utm', utmCookie );
	}
	
	if (typeof window.MktoForms2 !== 'undefined') {

		window.MktoForms2.whenReady(function (form) {
			
			var formId = form.getId();
			var $form = $('#mktoForm_' + formId);
			var $formParent = $form.parent();
			var formSettings = $formParent.data();
	
	
			const $conversionURLField = $('input[name="conversion_url"]');
			const $formIdfield = $('input[name="formid"]');
			const $lastLeadSource = $('input[name="Last_Converting_Lead_Source__c"]');
			const initialLeadSourceVal = $lastLeadSource.val();
	
			//prefill utm params fields form values in custom utm cookie.
			$('input[name="UTM_Campaign__c"]').val(getSubCookie('a_utm', 'utm_campaign'));
			$('input[name="UTM_Content__c"]').val(getSubCookie('a_utm', 'utm_content'));
			$('input[name="UTM_Medium__c"]').val(getSubCookie('a_utm', 'utm_medium'));
			$('input[name="UTM_Source__c"]').val(getSubCookie('a_utm', 'utm_source'));
			$('input[name="UTM_Term__c"]').val(getSubCookie('a_utm', 'utm_term'));
	
			if (formSettings.prefill) {
				var mtkoCookie = getCookie('a_mkto'), prefillString, prefillObj;
				if (mtkoCookie) {
					prefillString = atob(mtkoCookie); // decode values from cookie.
				}
	
				if (prefillString) {
					try {
						prefillObj = JSON.parse(prefillString);
						form.vals(prefillObj); //prefill fields with values from cookie
					} catch (e) {
						console.log(e);
					}
				}
	
				if (formSettings.hideOnPrefill) { // hide fields 
					if (typeof prefillObj == 'object') {
						var formFieldNames = Object.keys(prefillObj);
						$.each(formFieldNames, function (i, name) {
							$('[name="' + name + '"]').closest('.mktoFormRow').hide();
						});
	
						if (formSettings.hiddenButtonLabel) {
							$form.find('.mktoButton').text(formSettings.hiddenButtonLabel);
						}
	
						var vals = form.vals();
						var firstName = vals.FirstName;
	
						$formParent.find('.mktoHtmlText').hide(); // hide privacy message
						$formParent.append('<div class="u-mt-2"><a href="#" class="c-lnk-roll-up js-marketo-not-you">Not you?</a></div>'); // add Not you link
	
						if (firstName) {
							$formParent.prepend('<p>Welcome back, ' + firstName + '!</p>'); // add hello message
						}
					}
				}
	
				if ($conversionURLField.length) {
					$conversionURLField.val(window.location.href);
				}
	
				if ($formIdfield) {
					$formIdfield.val(formId);
				}
	
				if ($lastLeadSource) {
					$lastLeadSource.val(initialLeadSourceVal);
				}
			}
	
			form.onSuccess(function (values, followUpUrl) {
				setCookie('a_mkto', btoa(JSON.stringify(values))); // encode values so it is not saved explicitly
	
				// fire a custom event...
				if (window.dataLayer) window.dataLayer.push({
					'event': 'marketoFormSuccess',
					'form': form.getId()
				});
	
				if (formSettings.customRedirect) { // if form has custom redirect
					// lets give it a second to run any scripts
					setTimeout(function () {
						window.location.href = formSettings.customRedirect;
					}, 100);
					return false;
				} else if (formSettings.customMessage) { // if form has custom inline message
					$('<p>' + formSettings.customMessage + '</p>').insertAfter('#mktoForm_' + formId);
					$('#mktoForm_' + formId).hide();
					return false;
				}
			});
		});
	}
	try {
		$(document).on('click', '.js-marketo-not-you', function(e) {
			e.preventDefault();
			window.location.reload(true);
			deleteCookie('a_mkto');
		});
		
		$(document).on('click', '.mktoForm a.mktoNotYou', function () {
			deleteCookie('a_mkto');
		});
	}catch(e){
		console.log(3);
	}
}

export default init;